export const CONTACT_EMAIL = "info@movetender.com.au";

export const ContactEmail = ({ testid = "footer-contact-email" }) => (
  <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-kinetic underline-offset-4 hover:underline" data-testid={testid}>{CONTACT_EMAIL}</a>
);
